<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <v-expand-transition v-if="message || header">
    <section
      class="insight-message"
      aria-label="Date range warning"
      :class="{ 'warning-red': warningRed }"
      :data-png-remove="dataPngRemove ? true : undefined"
    >
      <div class="insight-message-wrapper">
        <div
          v-if="header"
          class="insight-message-header-row"
        >
          <h2 class="text-h2">
            <a
              v-if="beaconArticleId"
              href="#"
              class="article-link"
              :data-beacon-article-sidebar="beaconArticleId"
              @click.stop
            >
              {{ header }}
            </a>
            <span v-else>{{ header }}</span>
          </h2>
        </div>
        <p
          v-if="message"
          :style="{ 'margin-top': `${header ? 16 : 0}px` }"
        >
          <template
            v-for="(part, index) in messageParts"
            :key="index"
          >
            <b
              v-if="part.type === 'bold'"
              :key="`bold-${index}`"
            >{{ part.content }}</b>
            <span
              v-else
              :key="`text-${index}`"
            >{{ part.content }}</span>
          </template>
        </p>
      </div>
      <div
        class="close"
        @click.stop="$emit('close')"
      >
        <DpplSvg file-name="icon-close" />
      </div>
    </section>
  </v-expand-transition>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

export default {
  name: 'InsightMessageBanner',
  components: { DpplSvg },
  props: {
    message: { type: String, default: '' },
    header: { type: String, default: '' },
    beaconArticleId: { type: String, default: '' },
    dataPngRemove: { type: Boolean, default: false },
    warningRed: { type: Boolean, default: false },
  },
  emits: ['close'],
  computed: {
    messageParts() {
      const regex = /(<b>.*?<\/b>)/g;
      const parts = this.message.split(regex).map((content) => {
        if (content.startsWith('<b>')) {
          return { type: 'bold', content: content.slice(3, -4) };
        }
        return { type: 'text', content };
      });

      return parts;
    },
  },
};
</script>

<style scoped lang="less">
.insight-message {
  margin: 16px auto;
  padding: 16px;
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  color: @text-darkest;
  background-color: rgba(@basic-yellow, .2);
  width: 100%;
  flex: 1;
  .insight-message-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    .insight-message-header-row {
      width: 100%;
      color: @text-brand;
    }
  }
  .close {
    display: flex;
    align-items: flex-start;
    padding: 8px;
    border-radius: 25px;
    height: 25px;
    cursor: pointer;
    &:hover {
      background-color: rgba( 0, 0, 0, .1);
    }
  }

  &.warning-red {
    background-color: rgba(@basic-orange, .2);
    margin: 16px 16px 16px auto;
  }

  .article-link {
    color: @text-brand;
    text-decoration: underline;
  }
}
/* always present */
.expand-enter-active, .expand-leave-active {
  transition: all .3s ease;
  overflow: hidden;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter, .expand-leave-to {
  height: 0;
  padding: 0;
  opacity: 0;
}
</style>
